import { render } from "./MrateTypeUpdate.vue?vue&type=template&id=47606566&scoped=true"
import script from "./MrateTypeUpdate.vue?vue&type=script&lang=js"
export * from "./MrateTypeUpdate.vue?vue&type=script&lang=js"

import "./MrateTypeUpdate.vue?vue&type=style&index=0&id=47606566&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47606566"]])

export default __exports__